export default "__VITE_ASSET__CsFEn$rr__"